import type { FC } from "react";
import styles from "./Pitch.module.scss";
export const Pitch: FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.pitch}>
        <svg
          className={styles.centerCircle}
          viewBox="0 0 160 82"
          fill="#b7db92"
        >
          <path
            d="M159.404 1.584c0 44.07-35.46 79.796-79.202 79.796S1 45.654 1 1.584"
            strokeWidth="2px"
          />
        </svg>

        <svg className={styles.penaltyArea} viewBox="0 0 200 89">
          <path d="M199 89V18.986H1V89" strokeWidth="2px" />
          <path
            d="M144.401 89V65.234H54.865V89M145.132 18.875c-14.802-13.489-53.577-32.374-90.265 0"
            strokeWidth="2px"
          />
        </svg>
      </div>
    </div>
  );
};
